import React from 'react';
import { Briefcase, Sparkles, ClipboardList, Wand2, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { RECRUITER_DEMO_URL } from '../constants/recruiterContact';
import { RecruiterGateCard } from './Recruiter/RecruiterGateCard';
import { RecruiterPageShell } from './Recruiter/RecruiterPageShell';

interface RecruiterLoggedOutGateProps {
  returnTo?: string;
  showLogin?: boolean;
}

const FeatureLine: React.FC<{ icon: React.ReactNode; children: React.ReactNode }> = ({ icon, children }) => (
  <li className="flex items-start gap-2.5 text-[13px] text-slate-700 leading-snug">
    <span className="mt-0.5 inline-flex w-5 h-5 items-center justify-center rounded-full bg-pink-50 text-pink-500 ring-1 ring-pink-100 shrink-0">
      {icon}
    </span>
    <span>{children}</span>
  </li>
);

const RecruiterLoggedOutGate: React.FC<RecruiterLoggedOutGateProps> = ({
  returnTo = '/?tab=hire',
  showLogin = true,
}) => {
  const { t } = useTranslation(['hiringBoard', 'common']);
  const loginHref = `/login?mode=recruiter&return=${encodeURIComponent(returnTo)}`;

  return (
    <RecruiterPageShell noPadding contentClassName="flex min-h-screen items-center justify-center px-4 py-12">
      <RecruiterGateCard
        icon={<Briefcase className="size-6 text-white" />}
        title={t('hiringBoard:logged_out.headline')}
        description={t('hiringBoard:logged_out.description')}
      >
        <ul className="mt-7 space-y-3.5 text-left">
          <FeatureLine icon={<Sparkles className="w-3.5 h-3.5" />}>{t('hiringBoard:logged_out.feature_sourcing')}</FeatureLine>
          <FeatureLine icon={<ClipboardList className="w-3.5 h-3.5" />}>{t('hiringBoard:logged_out.feature_invite')}</FeatureLine>
          <FeatureLine icon={<Wand2 className="w-3.5 h-3.5" />}>{t('hiringBoard:logged_out.feature_formats')}</FeatureLine>
          <FeatureLine icon={<FileText className="w-3.5 h-3.5" />}>{t('hiringBoard:logged_out.feature_analysis')}</FeatureLine>
        </ul>
        <a
          href={RECRUITER_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 flex w-full items-center justify-center rounded-xl bg-gradient-to-r from-pink-500 to-rose-500 py-3 text-sm font-semibold text-white shadow-lg shadow-pink-500/20 transition-all hover:shadow-xl hover:shadow-pink-500/25"
        >
          {t('common:recruiterCta.bookDemo')}
        </a>
        {showLogin && (
          <a
            href={loginHref}
            className="mt-3 block text-center text-sm font-medium text-slate-500 transition-colors hover:text-slate-900"
          >
            {t('hiringBoard:logged_out.login')}
          </a>
        )}
      </RecruiterGateCard>
    </RecruiterPageShell>
  );
};

export default RecruiterLoggedOutGate;
